import React from 'react';
import { useTheme } from '../theme';

export type ToastContainerProps = React.HTMLAttributes<HTMLDivElement>;

export const ToastContainer = ({
  className,
  ...props
}: ToastContainerProps): React.ReactElement => {
  const theme = useTheme();

  return <div className={className} data-theme={theme} {...props} />;
};
